// React
import React from 'react';
// Material-UI
import { Grid, Button, CircularProgress } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
// Otras libs

// Componentes

// Funciones

// Hooks


/**
 *
 * @typedef {Object} CustomOpt
 * @property {boolean} eliminar Mostrar botón eliminar
 * @property {boolean} guardar Mostrar botón guardar
 */

/**
 * Especifica la función a ser ejecutada al hacer click en el botón
 * @callback OnClick
 * @param {React.MouseEventHandler<HTMLButtonElement>} event Evento de botón
 * @returns {Promise<void>}
 */

/**
 *
 * @typedef {Object} Props
 * @property {string} label Etiqueta de botón
 * @property {string} [form] Nombre formulario asociado
 * @property {string} isLoading Si se está cargando
 * @property {boolean} disabled Si botón se encuentra deshabilitado
 * @property {CustomOpt} [custom] Estilos de lista
 * @property {JSX.Element} leftActions Acciones
 * @property {OnClick} onClickDelete Evento al presionar botón eliminar
 * @property {OnClick} [onClickSave] Evento al presionar botón guardar
 */

/**
 * Botón de carga
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns
 */
export const BotonesEliminarGuardar = ({
    label = '',
    form,
    isLoading = false,
    custom = { eliminar: true, guardar: true },
    disabled = false,
    leftActions = undefined,
    onClickDelete = (event) => {},
    onClickSave,
}) => {
    // Idioma

    // Estados

    // Vista
    return (
        <Grid container justifyContent='space-between'>
            <Grid item>
                {custom.eliminar && (
                    <Button 
                        variant='contained' 
                        color='secondary' 
                        disabled={isLoading || disabled} 
                        onClick={onClickDelete}
                        disableElevation 
                    >
                        <DeleteIcon />
                    </Button>
                )}
                {leftActions}
            </Grid>
            <Grid item>
                {(custom.guardar === undefined || custom.guardar === null || custom.guardar) && (
                    <Button 
                        variant='contained' 
                        color='primary' 
                        type={form ? 'submit' : undefined} 
                        form={form} 
                        disabled={isLoading || disabled}
                        onClick={onClickSave}
                        disableElevation 
                    >
                        {isLoading && <CircularProgress size={20} style={{ marginRight: 5 }} />} {label}
                    </Button>
                )}
            </Grid>
        </Grid>
    );
};
